export class GeusLocationCalculateCommand {
    public locationNumber: string | null | undefined = undefined;
    public pollutionStatus: string | null | undefined = undefined;
    public shapeWkt: string | null | undefined = undefined;

    public constructor(init: Partial<GeusLocationCalculateCommand>) {
        Object.assign(this, init);
    }
}
